import styled from 'styled-components'

export const ShiftsContainer = styled.div`
  width: 100%;
  height: -webkit-fill-available;
  height: -moz-available;
  height: stretch;
  
  .noData {
    padding: 0.625rem 0.75rem 0.5rem;
  }
  
  .hidden {
    display: none !important;
  }
  
  .loader {
    position: absolute;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.2);
  }
`

export const Shift = styled.div`
  background: white;
  border-bottom: 3px solid #E0E0E0;
  padding: 0.813rem 1rem;

  display: flex;
  flex-direction: column;
  align-items: stretch;
  
  .row {
    display: flex;
  }
  
  .statuses {
    justify-content: unset;
    font-family: 'Lato', sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 1rem;
    line-height: 22px;
    color: #05132E;
    padding-top: 1rem;
  }
  .status:not(:first-child){
    padding-left: 1rem;
  }
  
  .postedOn {
    font-size: 0.875rem;
    font-weight: 500;
    color: #6D6D72;
  }
  
  .status {
    font-size: 0.925rem;
    line-height: 1.25rem;
    display: flex;
  }
  
  .half {
    width: 50%;
  }
`

export const ShiftHeader = styled.div`
  font-family: 'Lato';
  font-style: normal;
  font-weight: 700;
  font-size: 1rem;
  line-height: 1.375rem;
  color: #05132E;
  flex: none;
  order: 0;
  flex-grow: 0;
  
  padding: 0.375rem 0 0;
  flex-direction: column;
`

export const SmallBox = styled.div`
  display: flex;
  flex-direction: column;
  height: 2.75rem;
  justify-content: space-around;
  color: #05132E;
  font-size: 1rem;
  line-height: 1.375rem;
  padding-top: 1rem;
  white-space: pre-wrap;

  .title {
    font-size: 0.875rem;
    line-height: 1.125rem;
    color: #3F4755;
  }
`
